module.exports = {
  footerText: 'Copyright Maria Publishers © 2019',
  apiUrl: 'https://digimaria.info/Track/',
}
